export enum AsyncComponentRegistryEnum {
  RegistryTabs = 'RegistryTabs',
  RegistryListForm = 'RegistryListForm',
  RegistryMutateForm = 'RegistryMutateForm',
  RegistryList = 'RegistryList',
  RegistryMutate = 'RegistryMutate',
  RegistrySelector = 'RegistrySelector',

}

export const registryComponents = {
  [ AsyncComponentRegistryEnum.RegistryTabs ]: () => import( '@/components/registry/RegistryTabs.vue' ),
  [ AsyncComponentRegistryEnum.RegistryListForm ]: () => import( '@/components/registry/RegistryListForm.vue' ),
  [ AsyncComponentRegistryEnum.RegistryMutateForm ]: () => import( '@/components/registry/RegistryMutateForm.vue' ),
  [ AsyncComponentRegistryEnum.RegistryList ]: () => import( '@/views/registry/registryList/RegistryList.vue' ),
  [ AsyncComponentRegistryEnum.RegistryMutate ]: () => import( '@/views/registry/registryMutate/RegistryMutate.vue' ),
  [ AsyncComponentRegistryEnum.RegistrySelector ]: () => import( '@/components/registry/RegistrySelector.vue' ),

}
